import { __awaiter } from 'tslib';
import { getToken } from '../utils/accessToken.js';
import { getActiveOrgId } from '../utils/activeOrganization.js';
import baseDiscoverService from './base/baseDiscoverService.js';

/** Drawer page size the design is built around ("View 15 older items"). */
const NOTIFICATIONS_FEED_PAGE_SIZE = 15;
const getNotificationsUnreadCount = (config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const response = (yield baseDiscoverService.get("api/notifications/unread-count", config));
    return (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0;
});
/** The slides waiting for this page, in order (priority, then newest). Empty is `{ slides: [] }`. */
const getNotificationsPopup = (placement, config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const response = (yield baseDiscoverService.get("api/notifications/popup", Object.assign(Object.assign({}, config), { params: { placement } })));
    if (!response)
        return [];
    return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.slides) !== null && _b !== void 0 ? _b : [];
});
/** One page of the drawer: priority high first, then newest. */
const getNotificationsFeed = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* ({ skip = 0, limit = NOTIFICATIONS_FEED_PAGE_SIZE } = {}, config) {
    var _a, _b, _c, _d, _e, _f;
    const response = (yield baseDiscoverService.get("api/notifications", Object.assign(Object.assign({}, config), { params: { skip, limit } })));
    return {
        items: (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [],
        hasMore: (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.hasMore) !== null && _d !== void 0 ? _d : false,
        newThisMonth: (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.newThisMonth) !== null && _f !== void 0 ? _f : 0,
    };
});
const postNotificationEvents = (payload, config) => __awaiter(void 0, void 0, void 0, function* () {
    if (!payload.ids.length)
        return;
    yield baseDiscoverService.post("api/notifications/events", payload, config);
});
/**
 * The same events, for when the page is going away (`pagehide`). Browsers cancel an in-flight XHR
 * on unload, so this uses a keepalive fetch, which outlives the page, carrying the headers the
 * Discover axios instance would add. Fire and forget: nobody is left to read the answer.
 */
const sendNotificationEventsOnPageExit = (payload) => {
    var _a;
    if (!payload.ids.length || typeof fetch !== "function")
        return;
    const headers = { "Content-Type": "application/json" };
    const token = getToken();
    const activeOrgId = getActiveOrgId();
    if (token)
        headers.Authorization = `Bearer ${token}`;
    if (activeOrgId)
        headers["X-Peek-Organization"] = activeOrgId;
    if (process.env.PEEK_APP_API_VERSION)
        headers["x-peek-api-version"] = process.env.PEEK_APP_API_VERSION;
    const base = ((_a = process.env.PEEK_APP_DISCOVER_API_URL) !== null && _a !== void 0 ? _a : "").replace(/\/+$/, "");
    const url = new URL(`${base}/api/notifications/events`, window.location.origin).toString();
    fetch(url, { method: "POST", headers, body: JSON.stringify(payload), keepalive: true }).catch(() => undefined);
};

export { NOTIFICATIONS_FEED_PAGE_SIZE, getNotificationsFeed, getNotificationsPopup, getNotificationsUnreadCount, postNotificationEvents, sendNotificationEventsOnPageExit };
